import { DOCUMENT } from '@angular/common';
import { Injectable, Inject, NgZone } from '@angular/core';
import { IListener, IPopupsServiceInterface } from './popups-service.interface';

@Injectable({
  providedIn: 'root',
})
export class PopupsService implements IPopupsServiceInterface {
  private uniqueIDs: { [key: string]: string } = {};
  private document: Document;

  constructor(@Inject(DOCUMENT) document, private ngZone: NgZone) {
    this.document = document as Document;
  }

  runClickListener(listener: IListener): void {
    this.ngZone.runOutsideAngular(() => {
      this.document.addEventListener('click', listener);
    });
  }

  removeClickListener(listener: IListener): void {
    this.document.removeEventListener('click', listener);
  }

  public setUniqueID = (uniqueClass: string, id: string) => (this.uniqueIDs[uniqueClass] = id);
  public getUniqueID = (id: string) => this.uniqueIDs[id];
  public removeUniqueID = (id: string) => delete this.uniqueIDs[id];
  public getAllOpenPopups = () => ({ ...this.uniqueIDs });
}
